import {useState} from 'react';
import {PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {Button, Box} from "@chakra-ui/react";

const PaymentForm = ({data, redirect}) => {
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async () => {
    if (!stripe || !elements) {
      return;
    }
    setLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `https://localhost:3000/${redirect}`,
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.error(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
    setLoading(false);
  }

  return <Box>
      <PaymentElement />
      <Button isLoading={loading} mt={6} onClick={handleSubmit}>Make payment</Button>
  </Box>

}

export default PaymentForm;
